"use client";
import React from "react";
import reactHtmlParser from "react-html-parser";

export default function Description({data}) {
    return (
        <>
            {
                data?.section_data?.description &&
                reactHtmlParser(data?.section_data?.description)
            }
        </>
    );
}

